module.exports = __webpack_public_path__ + "img/box01.b5dd2a03.png";